export default {
  id: 'Timeline',
  code: 'CN',
  text: {
    "Title": "标题",
    "Due": "完成日期",
    "Remind At": "提醒日期",
    "Assign To": "分配给",
    "Note": "描述",
    "Also remind parents and students (If don't check, will only remind teacher)": "是否需要提醒家长以及学生（如果不勾选则只提醒分配老师）",
    "Save": "保存",
    "Cancel": "取消",
    
    "Create Task": "创建事项",
    "Edit Task": "编辑事项",
    'Add Task': '新增事项',
    'Completed': '已完成',
    'Pending': '未完成',
    'Recent': '近期事项',
    'Load More': '载入更多',

    'Planning': '时间规划',
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Timeline/locale.js